import * as React from 'react';
import { Row, Col, Label } from 'reactstrap';
import ReactHtmlParser from 'react-html-parser';
import { ICase } from 'src/share/types/case/case';
import { formatCapitalized, momentToString } from 'src/share/utils/utils';
import { getContactInformation } from 'src/share/utils/formatContactInfo';

export interface IPersonPosterProps {
  caseData: ICase;
  agencyName: string;
}

export class InformationCard extends React.Component<IPersonPosterProps> {
  public render() {
    const { caseId, agencyCode, openDate, missingDate, country, state, city, caseType, status, contactInformation, circumstances, miscellaneous, closedComments } = this.props.caseData;
    const { agencyName } = this.props;

    return (
      <Row>
        <Col className={`col-lg-${miscellaneous && miscellaneous.length > 0 ? '9' : '12'} col-md-${miscellaneous && miscellaneous.length > 0 ? '7' : '12'}`}>
          <div className="card white-background">
            <div className="content">
              <Row>
                <Col className="col-md-12">
                  <p className="case-id"><Label>Case ID:</Label>{agencyCode}-{caseId}</p>
                  <p className="case-open-date"><Label>Case open date:</Label>{momentToString(openDate)}</p>
                </Col>
              </Row>
              <Row>
                <Col className="col-md-12">
                  <Row>
                    <Col className="col-md-6">
                      <div className="case-info">
                        <p><Label>Missing date:</Label>{momentToString(missingDate)}</p>
                        <p><Label>Missing country:</Label>{country ? formatCapitalized(country) : 'Unknown'}</p>
                        <p><Label>Missing province:</Label>{state ? formatCapitalized(state) : 'Unknown'}</p>
                        <p><Label>Missing city:</Label>{city ? formatCapitalized(city) : 'Unknown'}</p>
                      </div>
                    </Col>
                    <Col className="col-md-6">
                      <div className="case-info">
                        <p><Label>Agency:</Label>{agencyName}</p>
                        <p><Label>Case type:</Label>{caseType ? formatCapitalized(caseType) : 'Unknown'}</p>
                        <p><Label>Status:</Label>{status ? formatCapitalized(status) : 'Unknown'}</p>
                        <p><Label>Public access:</Label>{this.props.caseData.public ? 'Visible' : 'Hidden'}</p>
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>
              <Row>
                <Col className="col-md-12">
                  <div className="case-detail">
                    <p><Label>Contact info:</Label></p>
                    <p>{contactInformation ? ReactHtmlParser(getContactInformation(contactInformation)) : 'Unknown'}</p>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col className="col-md-12">
                  <div className="case-detail">
                    <p><Label>Missing circumstances:</Label></p>
                    <p>{circumstances ? ReactHtmlParser(circumstances) : 'Unknown'}</p>
                  </div>
                </Col>
              </Row>
              {this.props.caseData.status === 'closed' &&
                <Row>
                  <Col className="col-md-12">
                    <div className="case-detail">
                      <p><Label>Closed comments:</Label></p>
                      <p>{closedComments ? closedComments : 'Unknown'}</p>
                    </div>
                  </Col>
                </Row>}
            </div>
          </div>
        </Col>
        {miscellaneous && miscellaneous.length > 0 ?
          <Col className="col-lg-3 col-md-5">
            <div className="card white-background">
              <div className="content">
                <Row>
                  <Col className="col-md-12">
                    <p className="case-miscellaneous-title"><Label>Miscellaneous pictures</Label></p>
                    {miscellaneous && miscellaneous.map((image, key) =>
                      <div className="miscellaneous-background" key={key}>
                        <img src={image} alt="portrait" />
                      </div>)}
                  </Col>
                </Row>
              </div>
            </div>
          </Col> :
          <></>}
      </Row>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/Case/InformationView/components/Information/components/InformationCard.tsx